import { ClassValue } from 'clsx';
import { isNil } from 'lodash';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import AddReactionsIcon from '@shared/assets/icons/v2/add-reactions.svg';
import AddressBookIcon from '@shared/assets/icons/v2/address-book.svg';
import AirplaneIcon from '@shared/assets/icons/v2/airplane.svg';
import AppCirclesIcon from '@shared/assets/icons/v2/app-circles.svg';
import AppleIcon from '@shared/assets/icons/v2/apple.svg';
import ArchiveBoxIcon from '@shared/assets/icons/v2/archive-box.svg';
import ArmStrongIcon from '@shared/assets/icons/v2/arm-strong.svg';
import ArrowCircleDownIcon from '@shared/assets/icons/v2/arrow-circle-down.svg';
import ArrowCircleUpIcon from '@shared/assets/icons/v2/arrow-circle-up.svg';
import ArrowExitIcon from '@shared/assets/icons/v2/arrow-exit.svg';
import ArrowFullDownIcon from '@shared/assets/icons/v2/arrow-full-down.svg';
import ArrowFullLeftIcon from '@shared/assets/icons/v2/arrow-full-left.svg';
import ArrowFullRightIcon from '@shared/assets/icons/v2/arrow-full-right.svg';
import ArrowFullUpFilledIcon from '@shared/assets/icons/v2/arrow-full-up-filled.svg';
import ArrowFullUpIcon from '@shared/assets/icons/v2/arrow-full-up.svg';
import ArrowLinkOutSmall2Icon from '@shared/assets/icons/v2/arrow-link-out-small-2.svg';
import ArrowLinkOutSmall3Icon from '@shared/assets/icons/v2/arrow-link-out-small-3.svg';
import ArrowLinkOutIcon from '@shared/assets/icons/v2/arrow-link-out.svg';
import ArrowMoveDownIcon from '@shared/assets/icons/v2/arrow-move-down.svg';
import ArrowMoveLeftIcon from '@shared/assets/icons/v2/arrow-move-left.svg';
import ArrowMoveRightIcon from '@shared/assets/icons/v2/arrow-move-right.svg';
import ArrowMoveUpIcon from '@shared/assets/icons/v2/arrow-move-up.svg';
import ArrowOutlineLeftIcon from '@shared/assets/icons/v2/arrow-outline-left.svg';
import ArrowOutlineRightIcon from '@shared/assets/icons/v2/arrow-outline-right.svg';
import ArrowPointDownHeavyIcon from '@shared/assets/icons/v2/arrow-point-down-heavy.svg';
import ArrowPointDownIcon from '@shared/assets/icons/v2/arrow-point-down.svg';
import ArrowPointLeftCircleIcon from '@shared/assets/icons/v2/arrow-point-left-circle.svg';
import ArrowPointLeftHeavyIcon from '@shared/assets/icons/v2/arrow-point-left-heavy.svg';
import ArrowPointLeftIcon from '@shared/assets/icons/v2/arrow-point-left.svg';
import ArrowPointRightCircleIcon from '@shared/assets/icons/v2/arrow-point-right-circle.svg';
import ArrowPointRightHeavyIcon from '@shared/assets/icons/v2/arrow-point-right-heavy.svg';
import ArrowPointRightIcon from '@shared/assets/icons/v2/arrow-point-right.svg';
import ArrowPointUpHeavyIcon from '@shared/assets/icons/v2/arrow-point-up-heavy.svg';
import ArrowPointUpIcon from '@shared/assets/icons/v2/arrow-point-up.svg';
import ArrowRefreshIcon from '@shared/assets/icons/v2/arrow-refresh.svg';
import ArrowRepeatIcon from '@shared/assets/icons/v2/arrow-repeat.svg';
import ArrowShuffleIcon from '@shared/assets/icons/v2/arrow-shuffle.svg';
import ArrowsCollapseIcon from '@shared/assets/icons/v2/arrows-collapse.svg';
import ArrowsExpandIcon from '@shared/assets/icons/v2/arrows-expand.svg';
import ArrowsSwapIcon from '@shared/assets/icons/v2/arrows-swap.svg';
import ArrowsUpDownHeavyIcon from '@shared/assets/icons/v2/arrows-up-down-heavy.svg';
import ArrowsUpDownInIcon from '@shared/assets/icons/v2/arrows-up-down-in.svg';
import ArrowsUpDownOutIcon from '@shared/assets/icons/v2/arrows-up-down-out.svg';
import ArrowsUpDownSwapIcon from '@shared/assets/icons/v2/arrows-up-down-swap.svg';
import ArrowsUpDownIcon from '@shared/assets/icons/v2/arrows-up-down.svg';
import AscendingIcon from '@shared/assets/icons/v2/ascending.svg';
import AtSymbolIcon from '@shared/assets/icons/v2/at-symbol.svg';
import AvatarAddGroupIcon from '@shared/assets/icons/v2/avatar-add-group.svg';
import AvatarEmptyIcon from '@shared/assets/icons/v2/avatar-empty.svg';
import AvatarGroupIcon from '@shared/assets/icons/v2/avatar-group.svg';
import AvatarInviteIcon from '@shared/assets/icons/v2/avatar-invite.svg';
import AvatarLocationIcon from '@shared/assets/icons/v2/avatar-location.svg';
import AvatarMultiIcon from '@shared/assets/icons/v2/avatar-multi.svg';
import AvatarPinIcon from '@shared/assets/icons/v2/avatar-pin.svg';
import AvatarSearchIcon from '@shared/assets/icons/v2/avatar-search.svg';
import AvatarIcon from '@shared/assets/icons/v2/avatar.svg';
import AwardIcon from '@shared/assets/icons/v2/award.svg';
import BagShoppingIcon from '@shared/assets/icons/v2/bag-shopping.svg';
import BasketballIcon from '@shared/assets/icons/v2/basketball.svg';
import BedIcon from '@shared/assets/icons/v2/bed.svg';
import BellHotelIcon from '@shared/assets/icons/v2/bell-hotel.svg';
import BellMutedIcon from '@shared/assets/icons/v2/bell-muted.svg';
import BellSnoozedIcon from '@shared/assets/icons/v2/bell-snoozed.svg';
import BellIcon from '@shared/assets/icons/v2/bell.svg';
import BillboardIcon from '@shared/assets/icons/v2/billboard.svg';
import BoardIcon from '@shared/assets/icons/v2/board.svg';
import BoldLightIcon from '@shared/assets/icons/v2/bold-light.svg';
import BookOpenIcon from '@shared/assets/icons/v2/book-open.svg';
import BookmarksIcon from '@shared/assets/icons/v2/bookmarks.svg';
import BoxCubeIcon from '@shared/assets/icons/v2/box-cube.svg';
import BriefcaseIcon from '@shared/assets/icons/v2/briefcase.svg';
import BuildingCapitolIcon from '@shared/assets/icons/v2/building-capitol.svg';
import BuildingCityIcon from '@shared/assets/icons/v2/building-city.svg';
import BuildingHotelIcon from '@shared/assets/icons/v2/building-hotel.svg';
import BullhornQuietIcon from '@shared/assets/icons/v2/bullhorn-quiet.svg';
import BullhornIcon from '@shared/assets/icons/v2/bullhorn.svg';
import ButtonPressIcon from '@shared/assets/icons/v2/button-press.svg';
import CakeBirthdayIcon from '@shared/assets/icons/v2/cake-birthday.svg';
import CalculatorIcon from '@shared/assets/icons/v2/calculator.svg';
import CalendarSmallIcon from '@shared/assets/icons/v2/calendar-small.svg';
import CalendarIcon from '@shared/assets/icons/v2/calendar.svg';
import CameraIcon from '@shared/assets/icons/v2/camera.svg';
import CarIcon from '@shared/assets/icons/v2/car.svg';
import CardIcon from '@shared/assets/icons/v2/card.svg';
import ChatBubblesSquareIcon from '@shared/assets/icons/v2/chat-bubbles-square.svg';
import ChatFilledSmallIcon from '@shared/assets/icons/v2/chat-filled-small.svg';
import ChatSmallIcon from '@shared/assets/icons/v2/chat-small.svg';
import ChatUrgentIcon from '@shared/assets/icons/v2/chat-urgent.svg';
import ChatIcon from '@shared/assets/icons/v2/chat.svg';
import CheckBoxEmptyIcon from '@shared/assets/icons/v2/check-box-empty.svg';
import CheckBoxIcon from '@shared/assets/icons/v2/check-box.svg';
import CheckFilledIcon from '@shared/assets/icons/v2/check-filled.svg';
import CheckSmallIcon from '@shared/assets/icons/v2/check-small.svg';
import CheckTaskIcon from '@shared/assets/icons/v2/check-task.svg';
import CheckTodoIcon from '@shared/assets/icons/v2/check-todo.svg';
import CheckIcon from '@shared/assets/icons/v2/check.svg';
import CircleAimIcon from '@shared/assets/icons/v2/circle-aim.svg';
import CircleIcon from '@shared/assets/icons/v2/circle.svg';
import ClockInIcon from '@shared/assets/icons/v2/clock-in.svg';
import ClockNoPaddingIcon from '@shared/assets/icons/v2/clock-no-padding.svg';
import ClockOutIcon from '@shared/assets/icons/v2/clock-out.svg';
import ClockIcon from '@shared/assets/icons/v2/clock.svg';
import CoastSymbolIcon from '@shared/assets/icons/v2/coast-symbol.svg';
import CoffeeIcon from '@shared/assets/icons/v2/coffee.svg';
import ConstructionCraneIcon from '@shared/assets/icons/v2/construction-crane.svg';
import ConstructionPaintbrushIcon from '@shared/assets/icons/v2/construction-paintbrush.svg';
import ConstructionSignIcon from '@shared/assets/icons/v2/construction-sign.svg';
import ContrastIcon from '@shared/assets/icons/v2/contrast.svg';
import CreditCardIcon from '@shared/assets/icons/v2/credit-card.svg';
import CutleryForkKnifeIcon from '@shared/assets/icons/v2/cutlery-fork-knife.svg';
import DeliveryCartIcon from '@shared/assets/icons/v2/delivery-cart.svg';
import DepartmentsIcon from '@shared/assets/icons/v2/departments.svg';
import DescendingIcon from '@shared/assets/icons/v2/descending.svg';
import DotsGrabNarrowIcon from '@shared/assets/icons/v2/dots-grab-narrow.svg';
import DotsTallIcon from '@shared/assets/icons/v2/dots-tall.svg';
import DotsWideIcon from '@shared/assets/icons/v2/dots-wide.svg';
import DotsIcon from '@shared/assets/icons/v2/dots.svg';
import DoughnutIcon from '@shared/assets/icons/v2/doughnut.svg';
import DumbbellIcon from '@shared/assets/icons/v2/dumbbell.svg';
import DuplicateSquaresIcon from '@shared/assets/icons/v2/duplicate-squares.svg';
import EnvelopeIcon from '@shared/assets/icons/v2/envelope.svg';
import EqualSignIcon from '@shared/assets/icons/v2/equal-sign.svg';
import EventCreateIcon from '@shared/assets/icons/v2/event-create.svg';
import ExclamationFilledIcon from '@shared/assets/icons/v2/exclamation-filled.svg';
import ExclamationOutlineIcon from '@shared/assets/icons/v2/exclamation-outline.svg';
import ExitNoBorderIcon from '@shared/assets/icons/v2/exit-no-border.svg';
import ExitSmallIcon from '@shared/assets/icons/v2/exit-small.svg';
import ExitIcon from '@shared/assets/icons/v2/exit.svg';
import EyeHideIcon from '@shared/assets/icons/v2/eye-hide.svg';
import EyeShowIcon from '@shared/assets/icons/v2/eye-show.svg';
import FaceCatIcon from '@shared/assets/icons/v2/face-cat.svg';
import FaceRobotIcon from '@shared/assets/icons/v2/face-robot.svg';
import FaceSadIcon from '@shared/assets/icons/v2/face-sad.svg';
import FaceSkullIcon from '@shared/assets/icons/v2/face-skull.svg';
import FaceSmileFilledIcon from '@shared/assets/icons/v2/face-smile-filled.svg';
import FaceSmileIcon from '@shared/assets/icons/v2/face-smile.svg';
import FaceWinkIcon from '@shared/assets/icons/v2/face-wink.svg';
import FileResumeIcon from '@shared/assets/icons/v2/file-resume.svg';
import FileSmallIcon from '@shared/assets/icons/v2/file-small.svg';
import FileIcon from '@shared/assets/icons/v2/file.svg';
import FilterFunnelIcon from '@shared/assets/icons/v2/filter-funnel.svg';
import FilterKnobsIcon from '@shared/assets/icons/v2/filter-knobs.svg';
import FireFlameIcon from '@shared/assets/icons/v2/fire-flame.svg';
import FlagWaveIcon from '@shared/assets/icons/v2/flag-wave.svg';
import FlagIcon from '@shared/assets/icons/v2/flag.svg';
import FlowerDaisyIcon from '@shared/assets/icons/v2/flower-daisy.svg';
import FlowerLotusIcon from '@shared/assets/icons/v2/flower-lotus.svg';
import FlowerTulipIcon from '@shared/assets/icons/v2/flower-tulip.svg';
import GearIcon from '@shared/assets/icons/v2/gear.svg';
import GifIcon from '@shared/assets/icons/v2/gif.svg';
import GlassesToastIcon from '@shared/assets/icons/v2/glasses-toast.svg';
import GlobalIcon from '@shared/assets/icons/v2/global.svg';
import GrainIcon from '@shared/assets/icons/v2/grain.svg';
import GraphAnalyticsIcon from '@shared/assets/icons/v2/graph-analytics.svg';
import GreaterThanEqualSignIcon from '@shared/assets/icons/v2/greater-than-equal-sign.svg';
import GreaterThanSignIcon from '@shared/assets/icons/v2/greater-than-sign.svg';
import GroupIcon from '@shared/assets/icons/v2/group.svg';
import HamburgerIcon from '@shared/assets/icons/v2/hamburger.svg';
import HandHeartIcon from '@shared/assets/icons/v2/hand-heart.svg';
import HandIcon from '@shared/assets/icons/v2/hand.svg';
import HandshakeIcon from '@shared/assets/icons/v2/handshake.svg';
import HashtagIcon from '@shared/assets/icons/v2/hashtag.svg';
import HatBaseballIcon from '@shared/assets/icons/v2/hat-baseball.svg';
import HatChefIcon from '@shared/assets/icons/v2/hat-chef.svg';
import HatCrownIcon from '@shared/assets/icons/v2/hat-crown.svg';
import HatGraduationIcon from '@shared/assets/icons/v2/hat-graduation.svg';
import HeadsetIcon from '@shared/assets/icons/v2/headset.svg';
import HeartBrokenIcon from '@shared/assets/icons/v2/heart-broken.svg';
import HeartIcon from '@shared/assets/icons/v2/heart.svg';
import HeartbeatIcon from '@shared/assets/icons/v2/heartbeat.svg';
import HouseLineIcon from '@shared/assets/icons/v2/house-line.svg';
import IdBadgeIcon from '@shared/assets/icons/v2/id-badge.svg';
import IdSymbolIcon from '@shared/assets/icons/v2/id-symbol.svg';
import ImageFilledIcon from '@shared/assets/icons/v2/image-filled.svg';
import ImagePortraitIcon from '@shared/assets/icons/v2/image-portrait.svg';
import ImageSmallIcon from '@shared/assets/icons/v2/image-small.svg';
import ImagestackIcon from '@shared/assets/icons/v2/imagestack.svg';
import InfoIIcon from '@shared/assets/icons/v2/info-i.svg';
import InfoOutlineIcon from '@shared/assets/icons/v2/info-outline.svg';
import InfoIcon from '@shared/assets/icons/v2/info.svg';
import InviteIcon from '@shared/assets/icons/v2/invite.svg';
import ItalicIcon from '@shared/assets/icons/v2/italic.svg';
import KeyIcon from '@shared/assets/icons/v2/key.svg';
import LayoutIcon from '@shared/assets/icons/v2/layout.svg';
import LeafIcon from '@shared/assets/icons/v2/leaf.svg';
import LessThanEqualSignIcon from '@shared/assets/icons/v2/less-than-equal-sign.svg';
import LessThanSignIcon from '@shared/assets/icons/v2/less-than-sign.svg';
import LightBulbIcon from '@shared/assets/icons/v2/light-bulb.svg';
import LightningBoltIcon from '@shared/assets/icons/v2/lightning-bolt.svg';
import LinkAddIcon from '@shared/assets/icons/v2/link-add.svg';
import LinkIcon from '@shared/assets/icons/v2/link.svg';
import ListIcon from '@shared/assets/icons/v2/list.svg';
import LockIcon from '@shared/assets/icons/v2/lock.svg';
import LogoIcon from '@shared/assets/icons/v2/logo.svg';
import MagicWandIcon from '@shared/assets/icons/v2/magic-wand.svg';
import MagnifyingGlassIcon from '@shared/assets/icons/v2/magnifying-glass.svg';
import MagnifyingSearch01Icon from '@shared/assets/icons/v2/magnifying-search-01.svg';
import MathIcon from '@shared/assets/icons/v2/math.svg';
import MedalIcon from '@shared/assets/icons/v2/medal.svg';
import MeterIcon from '@shared/assets/icons/v2/meter.svg';
import MicrophoneMuteIcon from '@shared/assets/icons/v2/microphone-mute.svg';
import MicrophoneOffIcon from '@shared/assets/icons/v2/microphone-off.svg';
import MicrophoneIcon from '@shared/assets/icons/v2/microphone.svg';
import MinusIcon from '@shared/assets/icons/v2/minus.svg';
import MobileAddIcon from '@shared/assets/icons/v2/mobile-add.svg';
import MobileChatIcon from '@shared/assets/icons/v2/mobile-chat.svg';
import MoneyBagIcon from '@shared/assets/icons/v2/money-bag.svg';
import MoneyCoinsIcon from '@shared/assets/icons/v2/money-coins.svg';
import MoneyDollarCircleIcon from '@shared/assets/icons/v2/money-dollar-circle.svg';
import MoneyReceiptIcon from '@shared/assets/icons/v2/money-receipt.svg';
import MoneyRefundIcon from '@shared/assets/icons/v2/money-refund.svg';
import MoonIcon from '@shared/assets/icons/v2/moon.svg';
import MultiLineIcon from '@shared/assets/icons/v2/multi-line.svg';
import MusicNotesIcon from '@shared/assets/icons/v2/music-notes.svg';
import NewGroupIcon from '@shared/assets/icons/v2/new-group.svg';
import NoEntryIcon from '@shared/assets/icons/v2/no_entry.svg';
import NotebookIcon from '@shared/assets/icons/v2/notebook.svg';
import PacmanIcon from '@shared/assets/icons/v2/pacman.svg';
import PaletteIcon from '@shared/assets/icons/v2/palette.svg';
import PaperclipIcon from '@shared/assets/icons/v2/paperclip.svg';
import PartyCelebrateIcon from '@shared/assets/icons/v2/party-celebrate.svg';
import PenFilledIcon from '@shared/assets/icons/v2/pen-filled.svg';
import PenIcon from '@shared/assets/icons/v2/pen.svg';
import PencilPaperIcon from '@shared/assets/icons/v2/pencil-paper.svg';
import PencilIcon from '@shared/assets/icons/v2/pencil.svg';
import PeopleIcon from '@shared/assets/icons/v2/people.svg';
import PercentIcon from '@shared/assets/icons/v2/percent.svg';
import PersonChefIcon from '@shared/assets/icons/v2/person-chef.svg';
import PersonConciergeIcon from '@shared/assets/icons/v2/person-concierge.svg';
import PersonManIcon from '@shared/assets/icons/v2/person-man.svg';
import PersonOfficerIcon from '@shared/assets/icons/v2/person-officer.svg';
import PersonTinyHeavyIcon from '@shared/assets/icons/v2/person-tiny-heavy.svg';
import PersonWomanIcon from '@shared/assets/icons/v2/person-woman.svg';
import PersonIcon from '@shared/assets/icons/v2/person.svg';
import PhoneIcon from '@shared/assets/icons/v2/phone.svg';
import PieIcon from '@shared/assets/icons/v2/pie.svg';
import PinLocationIcon from '@shared/assets/icons/v2/pin-location.svg';
import PinWorldIcon from '@shared/assets/icons/v2/pin-world.svg';
import PlugIcon from '@shared/assets/icons/v2/plug.svg';
import PlusCircleFilledIcon from '@shared/assets/icons/v2/plus-circle-filled.svg';
import PlusCircleIcon from '@shared/assets/icons/v2/plus-circle.svg';
import PlusSmallHeavyIcon from '@shared/assets/icons/v2/plus-small-heavy.svg';
import PlusIcon from '@shared/assets/icons/v2/plus.svg';
import PotionIcon from '@shared/assets/icons/v2/potion.svg';
import PresentIcon from '@shared/assets/icons/v2/present.svg';
import PushPinIcon from '@shared/assets/icons/v2/push-pin.svg';
import QrCodeIcon from '@shared/assets/icons/v2/qr-code.svg';
import QuestionMarkIcon from '@shared/assets/icons/v2/question-mark.svg';
import RadioButtonIcon from '@shared/assets/icons/v2/radio-button.svg';
import ReceiptLongIcon from '@shared/assets/icons/v2/receipt-long.svg';
import RemoveFilledSmallIcon from '@shared/assets/icons/v2/remove-filled-small.svg';
import RemoveFilledIcon from '@shared/assets/icons/v2/remove-filled.svg';
import RemoveXOutlinedIcon from '@shared/assets/icons/v2/remove-x-outlined.svg';
import RemoveXIcon from '@shared/assets/icons/v2/remove-x.svg';
import RemoveIcon from '@shared/assets/icons/v2/remove.svg';
import RepeatIcon from '@shared/assets/icons/v2/repeat.svg';
import RoadSignIcon from '@shared/assets/icons/v2/road-sign.svg';
import ScaleJusticeIcon from '@shared/assets/icons/v2/scale-justice.svg';
import ScreenshareIcon from '@shared/assets/icons/v2/screenshare.svg';
import SearchLookUpIcon from '@shared/assets/icons/v2/search-look-up.svg';
import SendCircleIcon from '@shared/assets/icons/v2/send-circle.svg';
import SendFilledIcon from '@shared/assets/icons/v2/send-filled.svg';
import SendOutlineIcon from '@shared/assets/icons/v2/send-outline.svg';
import SignBoardIcon from '@shared/assets/icons/v2/sign-board.svg';
import SignatureBallpointPenIcon from '@shared/assets/icons/v2/signature-ballpoint-pen.svg';
import SingleSelectListIcon from '@shared/assets/icons/v2/single-select-list.svg';
import SingleViewIcon from '@shared/assets/icons/v2/single-view.svg';
import SlideLeftArrowIcon from '@shared/assets/icons/v2/slide-left-arrow.svg';
import SlideRightArrowIcon from '@shared/assets/icons/v2/slide-right-arrow.svg';
import SmileIcon from '@shared/assets/icons/v2/smile.svg';
import SnowmanIcon from '@shared/assets/icons/v2/snowman.svg';
import SparkleIcon from '@shared/assets/icons/v2/sparkle.svg';
import SplitViewIcon from '@shared/assets/icons/v2/split-view.svg';
import SquaresStackedIcon from '@shared/assets/icons/v2/squares-stacked.svg';
import SquaresIcon from '@shared/assets/icons/v2/squares.svg';
import StackCardsIcon from '@shared/assets/icons/v2/stack-cards.svg';
import StarOutlineIcon from '@shared/assets/icons/v2/star-outline.svg';
import StarRateIcon from '@shared/assets/icons/v2/star-rate.svg';
import StarIcon from '@shared/assets/icons/v2/star.svg';
import StartPlayTimerIcon from '@shared/assets/icons/v2/start-play-timer.svg';
import StethoscopeIcon from '@shared/assets/icons/v2/stethoscope.svg';
import StoreLocationIcon from '@shared/assets/icons/v2/store-location.svg';
import StoreShopIcon from '@shared/assets/icons/v2/store-shop.svg';
import StorefrontSquareIcon from '@shared/assets/icons/v2/storefront-square.svg';
import StorefrontIcon from '@shared/assets/icons/v2/storefront.svg';
import SunIcon from '@shared/assets/icons/v2/sun.svg';
import SunsetIcon from '@shared/assets/icons/v2/sunset.svg';
import SupportGrayIcon from '@shared/assets/icons/v2/support-gray.svg';
import SwapSmallIcon from '@shared/assets/icons/v2/swap-small.svg';
import SwapIcon from '@shared/assets/icons/v2/swap.svg';
import SyringeIcon from '@shared/assets/icons/v2/syringe.svg';
import TabIcon from '@shared/assets/icons/v2/tab.svg';
import TableGridIcon from '@shared/assets/icons/v2/table-grid.svg';
import TagShoppingIcon from '@shared/assets/icons/v2/tag-shopping.svg';
import TagIcon from '@shared/assets/icons/v2/tag.svg';
import TargetIcon from '@shared/assets/icons/v2/target.svg';
import TaskFilledIcon from '@shared/assets/icons/v2/task-filled.svg';
import TaskIcon from '@shared/assets/icons/v2/task.svg';
import ThumbDownIcon from '@shared/assets/icons/v2/thumb-down.svg';
import ThumbUpIcon from '@shared/assets/icons/v2/thumb-up.svg';
import TicketIcon from '@shared/assets/icons/v2/ticket.svg';
import TimeAlarmIcon from '@shared/assets/icons/v2/time-alarm.svg';
import TimeClockIcon from '@shared/assets/icons/v2/time-clock.svg';
import TimeHourglassIcon from '@shared/assets/icons/v2/time-hourglass.svg';
import TimeRepeatIcon from '@shared/assets/icons/v2/time-repeat.svg';
import TimeStopwatchIcon from '@shared/assets/icons/v2/time-stopwatch.svg';
import TimeUrgentIcon from '@shared/assets/icons/v2/time-urgent.svg';
import TimeWatchIcon from '@shared/assets/icons/v2/time-watch.svg';
import TitleTIcon from '@shared/assets/icons/v2/title-t.svg';
import TrashIcon from '@shared/assets/icons/v2/trash.svg';
import TreeEvergreenIcon from '@shared/assets/icons/v2/tree-evergreen.svg';
import TrophyIcon from '@shared/assets/icons/v2/trophy.svg';
import TruckDeliveryIcon from '@shared/assets/icons/v2/truck-delivery.svg';
import TruckFrontIcon from '@shared/assets/icons/v2/truck-front.svg';
import UmbrellaIcon from '@shared/assets/icons/v2/umbrella.svg';
import UnderlineLightIcon from '@shared/assets/icons/v2/underline-light.svg';
import UnfilledCircleIcon from '@shared/assets/icons/v2/unfilled-circle.svg';
import UploadArrowIcon from '@shared/assets/icons/v2/upload-arrow.svg';
import UrgentIcon from '@shared/assets/icons/v2/urgent.svg';
import VideoRecorderIcon from '@shared/assets/icons/v2/video-recorder.svg';
import WaterDropIcon from '@shared/assets/icons/v2/water-drop.svg';
import WaterFaucetIcon from '@shared/assets/icons/v2/water-faucet.svg';
import WavesIcon from '@shared/assets/icons/v2/waves.svg';
import WrenchToolsIcon from '@shared/assets/icons/v2/wrench-tools.svg';
import WrenchIcon from '@shared/assets/icons/v2/wrench.svg';
import ZzzsIcon from '@shared/assets/icons/v2/zzzs.svg';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { SharedStyles } from '@shared/styles';
import { MBImage } from './MBImage';
import classNames from './iconV2.module.css';
import { MBImageURISource } from './props';
import { Styles } from './styles';

export const MBIconV2NameMap = {
  'add-reactions': AddReactionsIcon,
  'address-book': AddressBookIcon,
  airplane: AirplaneIcon,
  'app-circles': AppCirclesIcon,
  apple: AppleIcon,
  'archive-box': ArchiveBoxIcon,
  'arm-strong': ArmStrongIcon,
  'arrow-circle-down': ArrowCircleDownIcon,
  'arrow-circle-up': ArrowCircleUpIcon,
  'arrow-exit': ArrowExitIcon,
  'arrow-full-down': ArrowFullDownIcon,
  'arrow-full-left': ArrowFullLeftIcon,
  'arrow-full-right': ArrowFullRightIcon,
  'arrow-full-up-filled': ArrowFullUpFilledIcon,
  'arrow-full-up': ArrowFullUpIcon,
  'arrow-link-out': ArrowLinkOutIcon,
  'arrow-link-out-small-2': ArrowLinkOutSmall2Icon,
  'arrow-link-out-small-3': ArrowLinkOutSmall3Icon,
  'arrow-move-down': ArrowMoveDownIcon,
  'arrow-move-left': ArrowMoveLeftIcon,
  'arrow-move-right': ArrowMoveRightIcon,
  'arrow-move-up': ArrowMoveUpIcon,
  'arrow-outline-left': ArrowOutlineLeftIcon,
  'arrow-outline-right': ArrowOutlineRightIcon,
  'arrow-point-down-heavy': ArrowPointDownHeavyIcon,
  'arrow-point-down': ArrowPointDownIcon,
  'arrow-point-left-heavy': ArrowPointLeftHeavyIcon,
  'arrow-point-left': ArrowPointLeftIcon,
  'arrow-point-left-circle': ArrowPointLeftCircleIcon,
  'arrow-point-right-heavy': ArrowPointRightHeavyIcon,
  'arrow-point-right': ArrowPointRightIcon,
  'arrow-point-right-circle': ArrowPointRightCircleIcon,
  'arrow-point-up-heavy': ArrowPointUpHeavyIcon,
  'arrow-point-up': ArrowPointUpIcon,
  'arrow-refresh': ArrowRefreshIcon,
  'arrow-repeat': ArrowRepeatIcon,
  'arrow-shuffle': ArrowShuffleIcon,
  'arrows-collapse': ArrowsCollapseIcon,
  'arrows-expand': ArrowsExpandIcon,
  'arrows-swap': ArrowsSwapIcon,
  'arrows-up-down-heavy': ArrowsUpDownHeavyIcon,
  'arrows-up-down-in': ArrowsUpDownInIcon,
  'arrows-up-down-out': ArrowsUpDownOutIcon,
  'arrows-up-down': ArrowsUpDownIcon,
  'arrows-up-down-swap': ArrowsUpDownSwapIcon,
  ascending: AscendingIcon,
  'at-symbol': AtSymbolIcon,
  'avatar-add-group': AvatarAddGroupIcon,
  'avatar-empty': AvatarEmptyIcon,
  'avatar-group': AvatarGroupIcon,
  'avatar-invite': AvatarInviteIcon,
  'avatar-location': AvatarLocationIcon,
  'avatar-multi': AvatarMultiIcon,
  'avatar-pin': AvatarPinIcon,
  'avatar-search': AvatarSearchIcon,
  avatar: AvatarIcon,
  award: AwardIcon,
  'bag-shopping': BagShoppingIcon,
  basketball: BasketballIcon,
  bed: BedIcon,
  'bell-hotel': BellHotelIcon,
  'bell-muted': BellMutedIcon,
  'bell-snoozed': BellSnoozedIcon,
  bell: BellIcon,
  billboard: BillboardIcon,
  board: BoardIcon,
  'bold-light': BoldLightIcon,
  'book-open': BookOpenIcon,
  bookmarks: BookmarksIcon,
  'box-cube': BoxCubeIcon,
  briefcase: BriefcaseIcon,
  'building-capitol': BuildingCapitolIcon,
  'building-city': BuildingCityIcon,
  'building-hotel': BuildingHotelIcon,
  'bullhorn-quiet': BullhornQuietIcon,
  bullhorn: BullhornIcon,
  'button-press': ButtonPressIcon,
  'cake-birthday': CakeBirthdayIcon,
  calculator: CalculatorIcon,
  'calendar-small': CalendarSmallIcon,
  calendar: CalendarIcon,
  camera: CameraIcon,
  car: CarIcon,
  card: CardIcon,
  'chat-bubbles-square': ChatBubblesSquareIcon,
  'chat-filled-small': ChatFilledSmallIcon,
  'chat-small': ChatSmallIcon,
  'chat-urgent': ChatUrgentIcon,
  chat: ChatIcon,
  'check-box': CheckBoxIcon,
  'check-box-empty': CheckBoxEmptyIcon,
  'check-filled': CheckFilledIcon,
  'check-small': CheckSmallIcon,
  'check-task': CheckTaskIcon,
  'check-todo': CheckTodoIcon,
  check: CheckIcon,
  'circle-aim': CircleAimIcon,
  circle: CircleIcon,
  'clock-out': ClockOutIcon,
  'clock-no-padding': ClockNoPaddingIcon,
  'clock-in': ClockInIcon,
  clock: ClockIcon,
  'coast-symbol': CoastSymbolIcon,
  coffee: CoffeeIcon,
  'construction-crane': ConstructionCraneIcon,
  'construction-paintbrush': ConstructionPaintbrushIcon,
  'construction-sign': ConstructionSignIcon,
  contrast: ContrastIcon,
  'credit-card': CreditCardIcon,
  'cutlery-fork-knife': CutleryForkKnifeIcon,
  departments: DepartmentsIcon,
  'delivery-cart': DeliveryCartIcon,
  descending: DescendingIcon,
  'dots-tall': DotsTallIcon,
  'dots-wide': DotsWideIcon,
  dots: DotsIcon,
  'dots-grab-narrow': DotsGrabNarrowIcon,
  doughnut: DoughnutIcon,
  dumbbell: DumbbellIcon,
  'duplicate-squares': DuplicateSquaresIcon,
  squares: SquaresIcon,
  envelope: EnvelopeIcon,
  'equal-sign': EqualSignIcon,
  'event-create': EventCreateIcon,
  exit: ExitIcon,
  'exit-no-border': ExitNoBorderIcon,
  'exclamation-filled': ExclamationFilledIcon,
  'exclamation-outline': ExclamationOutlineIcon,
  'exit-small': ExitSmallIcon,
  'eye-hide': EyeHideIcon,
  'eye-show': EyeShowIcon,
  'face-cat': FaceCatIcon,
  'face-robot': FaceRobotIcon,
  'face-sad': FaceSadIcon,
  'face-skull': FaceSkullIcon,
  'face-smile-filled': FaceSmileFilledIcon,
  'face-smile': FaceSmileIcon,
  'face-wink': FaceWinkIcon,
  'file-resume': FileResumeIcon,
  'file-small': FileSmallIcon,
  file: FileIcon,
  'filter-funnel': FilterFunnelIcon,
  'filter-knobs': FilterKnobsIcon,
  'fire-flame': FireFlameIcon,
  'flag-wave': FlagWaveIcon,
  flag: FlagIcon,
  'flower-daisy': FlowerDaisyIcon,
  'flower-lotus': FlowerLotusIcon,
  'flower-tulip': FlowerTulipIcon,
  gear: GearIcon,
  gif: GifIcon,
  'glasses-toast': GlassesToastIcon,
  global: GlobalIcon,
  grain: GrainIcon,
  'graph-analytics': GraphAnalyticsIcon,
  'greater-than-sign': GreaterThanSignIcon,
  'greater-than-equal-sign': GreaterThanEqualSignIcon,
  group: GroupIcon,
  hamburger: HamburgerIcon,
  'hand-heart': HandHeartIcon,
  hand: HandIcon,
  handshake: HandshakeIcon,
  hashtag: HashtagIcon,
  'hat-baseball': HatBaseballIcon,
  'hat-chef': HatChefIcon,
  'hat-crown': HatCrownIcon,
  'hat-graduation': HatGraduationIcon,
  headset: HeadsetIcon,
  'heart-broken': HeartBrokenIcon,
  heart: HeartIcon,
  heartbeat: HeartbeatIcon,
  'house-line': HouseLineIcon,
  'id-badge': IdBadgeIcon,
  'id-symbol': IdSymbolIcon,
  'image-filled': ImageFilledIcon,
  'image-portrait': ImagePortraitIcon,
  'image-small': ImageSmallIcon,
  imagestack: ImagestackIcon,
  info: InfoIcon,
  'info-i': InfoIIcon,
  'info-outline': InfoOutlineIcon,
  invite: InviteIcon,
  italic: ItalicIcon,
  key: KeyIcon,
  layout: LayoutIcon,
  leaf: LeafIcon,
  'less-than-sign': LessThanSignIcon,
  'less-than-equal-sign': LessThanEqualSignIcon,
  'light-bulb': LightBulbIcon,
  'lightning-bolt': LightningBoltIcon,
  'link-add': LinkAddIcon,
  link: LinkIcon,
  list: ListIcon,
  lock: LockIcon,
  logo: LogoIcon,
  'magic-wand': MagicWandIcon,
  'magnifying-glass': MagnifyingGlassIcon,
  'magnifying-search-01': MagnifyingSearch01Icon,
  math: MathIcon,
  medal: MedalIcon,
  meter: MeterIcon,
  microphone: MicrophoneIcon,
  'microphone-mute': MicrophoneMuteIcon,
  'microphone-off': MicrophoneOffIcon,
  minus: MinusIcon,
  'mobile-add': MobileAddIcon,
  'mobile-chat': MobileChatIcon,
  'money-bag': MoneyBagIcon,
  'money-coins': MoneyCoinsIcon,
  'money-dollar-circle': MoneyDollarCircleIcon,
  'money-receipt': MoneyReceiptIcon,
  'money-refund': MoneyRefundIcon,
  moon: MoonIcon,
  'multi-line': MultiLineIcon,
  'music-notes': MusicNotesIcon,
  'new-group': NewGroupIcon,
  no_entry: NoEntryIcon,
  notebook: NotebookIcon,
  pacman: PacmanIcon,
  palette: PaletteIcon,
  paperclip: PaperclipIcon,
  'party-celebrate': PartyCelebrateIcon,
  'pen-filled': PenFilledIcon,
  pen: PenIcon,
  'pencil-paper': PencilPaperIcon,
  pencil: PencilIcon,
  people: PeopleIcon,
  percent: PercentIcon,
  'person-chef': PersonChefIcon,
  'person-concierge': PersonConciergeIcon,
  'person-man': PersonManIcon,
  'person-officer': PersonOfficerIcon,
  'person-tiny-heavy': PersonTinyHeavyIcon,
  'person-woman': PersonWomanIcon,
  person: PersonIcon,
  phone: PhoneIcon,
  pie: PieIcon,
  'pin-location': PinLocationIcon,
  'pin-world': PinWorldIcon,
  plug: PlugIcon,
  'plus-circle-filled': PlusCircleFilledIcon,
  'plus-circle': PlusCircleIcon,
  'plus-small-heavy': PlusSmallHeavyIcon,
  plus: PlusIcon,
  'push-pin': PushPinIcon,
  potion: PotionIcon,
  present: PresentIcon,
  'qr-code': QrCodeIcon,
  'question-mark': QuestionMarkIcon,
  'radio-button': RadioButtonIcon,
  'receipt-long': ReceiptLongIcon,
  'remove-filled': RemoveFilledIcon,
  'remove-filled-small': RemoveFilledSmallIcon,
  'remove-x': RemoveXIcon,
  'remove-x-outlined': RemoveXOutlinedIcon,
  remove: RemoveIcon,
  repeat: RepeatIcon,
  'road-sign': RoadSignIcon,
  'scale-justice': ScaleJusticeIcon,
  screenshare: ScreenshareIcon,
  'search-look-up': SearchLookUpIcon,
  'send-circle': SendCircleIcon,
  'send-filled': SendFilledIcon,
  'send-outline': SendOutlineIcon,
  'sign-board': SignBoardIcon,
  'signature-ballpoint-pen': SignatureBallpointPenIcon,
  'single-select-list': SingleSelectListIcon,
  'single-view': SingleViewIcon,
  'slide-left-arrow': SlideLeftArrowIcon,
  'slide-right-arrow': SlideRightArrowIcon,
  smile: SmileIcon,
  snowman: SnowmanIcon,
  sparkle: SparkleIcon,
  'split-view': SplitViewIcon,
  'squares-stacked': SquaresStackedIcon,
  'stack-cards': StackCardsIcon,
  'star-outline': StarOutlineIcon,
  'star-rate': StarRateIcon,
  star: StarIcon,
  'start-play-timer': StartPlayTimerIcon,
  stethoscope: StethoscopeIcon,
  'store-location': StoreLocationIcon,
  'store-shop': StoreShopIcon,
  'storefront-square': StorefrontSquareIcon,
  storefront: StorefrontIcon,
  sun: SunIcon,
  sunset: SunsetIcon,
  'support-gray': SupportGrayIcon,
  'swap-small': SwapSmallIcon,
  swap: SwapIcon,
  syringe: SyringeIcon,
  tab: TabIcon,
  'table-grid': TableGridIcon,
  'tag-shopping': TagShoppingIcon,
  tag: TagIcon,
  target: TargetIcon,
  'task-filled': TaskFilledIcon,
  task: TaskIcon,
  'thumb-down': ThumbDownIcon,
  'thumb-up': ThumbUpIcon,
  ticket: TicketIcon,
  'time-alarm': TimeAlarmIcon,
  'time-clock': TimeClockIcon,
  'time-hourglass': TimeHourglassIcon,
  'time-repeat': TimeRepeatIcon,
  'time-stopwatch': TimeStopwatchIcon,
  'time-urgent': TimeUrgentIcon,
  'time-watch': TimeWatchIcon,
  'title-t': TitleTIcon,
  trash: TrashIcon,
  'tree-evergreen': TreeEvergreenIcon,
  trophy: TrophyIcon,
  'truck-delivery': TruckDeliveryIcon,
  'truck-front': TruckFrontIcon,
  umbrella: UmbrellaIcon,
  'underline-light': UnderlineLightIcon,
  'unfilled-circle': UnfilledCircleIcon,
  'upload-arrow': UploadArrowIcon,
  urgent: UrgentIcon,
  'video-recorder': VideoRecorderIcon,
  'water-drop': WaterDropIcon,
  'water-faucet': WaterFaucetIcon,
  waves: WavesIcon,
  'wrench-tools': WrenchToolsIcon,
  wrench: WrenchIcon,
  zzzs: ZzzsIcon,
};

export function getIconV2(icon: keyof typeof MBIconV2NameMap): MBImageURISource {
  return MBIconV2NameMap[icon];
}

export type MBIconV2Name = keyof typeof MBIconV2NameMap;

export interface MBIconV2Props {
  color?: string;
  name?: MBIconV2Name;
  size?: number;
  style?: StyleProp<ViewStyle>;
  className?: ClassValue;
  testID?: string;
}

export function MBIconV2({ name, color, size, style, className, testID }: MBIconV2Props) {
  const icon = !isNil(name) && MBIconV2NameMap[name];
  if (!icon) {
    return null;
  }

  if (isNil(style)) {
    return (
      <View className={[classNames.iconv2, className]} vars={{ size }} testID={testID}>
        <MBImage style={SharedStyles.full} resizeMode="contain" source={icon} tintColor={color} />
      </View>
    );
  } else {
    return (
      <MBView
        style={[Styles.iconv2, !!size && { width: size, height: size }, style]}
        testID={testID}
      >
        <MBImage style={SharedStyles.full} resizeMode="contain" source={icon} tintColor={color} />
      </MBView>
    );
  }
}
